import { Actions, Badge, EyeIcon, Link, Tooltip } from "@";
import { MessageStatusOptions, messagesTypesOptions } from "../utils/options";

// Component for rendering table actions
export const TableActions = ({ row, deleteHandler }) => {
  return (
    <>
      <Actions
        delete={deleteHandler}
        url="messages/automated"
        notShow
        row={row}
      >
        <>
          <Link
            data-tooltip-placement="right"
            to={`/automated/${row.id}`}
            className="icon-style cursor-pointer"
            data-tooltip-target={`action-z-${row.id}`}
          >
            <EyeIcon className="w-6" />
          </Link>
          <Tooltip
            className="dark:bg-gray-600"
            title="عرض"
            id={`action-z-${row.id}`}
          />
        </>
      </Actions>
    </>
  );
};

const formattedDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  return date?.toISOString().slice(0, 16).replace("T", " ");
};

// Define the columns for the table
export const tableColumns = [
  {
    name: "تاريخ الجدولة",
    selector: ({ scheduledDateTime }) => formattedDate(scheduledDateTime),
  },
  {
    name: "محتوى الرسالة",
    selector: ({ messageContent }) => messageContent,
  },
  {
    name: "التصنيف",
    cell: ({ category }) => (
      <Badge
        title={
          messagesTypesOptions.find((type) => type.value === category)?.name
        }
        color={
          category === "FailedRecurring"
            ? "red"
            : category === "FailedDonation"
              ? "red"
              : category === "CompletedProject"
                ? "green"
                : category === "SuccessDonations"
                  ? "green"
                  : ""
        }
      />
    ),
  },
  {
    name: "حالة الارسال",
    cell: ({ messageStatus }) => (
      <Badge
        title={
          MessageStatusOptions.find((type) => type.english === messageStatus)
            ?.name
        }
        color={
          messageStatus === "Sent"
            ? "green"
            : messageStatus === "NotSent"
              ? "red"
              : messageStatus === "InProgress"
                ? "yellow"
                : messageStatus === "New"
                  ? "default"
                  : messageStatus === "Disabled"
                    ? "dark"
                    : ""
        }
      />
    ),
  },
];
